import { embed } from "framer-motion/client";
import React from "react";

function EmployeeDetails({ empDetails, clickReset, clickEdit, clickDelete }) {
  console.log(empDetails);
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        User Details
      </h6>
      {empDetails?.employee ? (
        <>
          <p className="mb-1">
            <strong>Name:</strong> {empDetails?.employee?.firstName}{" "}
            {empDetails?.employee?.middleName} {empDetails?.employee?.lastName}
          </p>
          <p className="mb-1">
            <strong>Position:</strong> {empDetails?.employee?.position}
          </p>
          <p className="mb-1">
            <strong>Date Hired:</strong> {empDetails?.employee?.dateHired || ""}
          </p>
          <p className="mb-1">
            <strong>Birthdate:</strong>{" "}
            {new Date(empDetails?.employee?.birthDate).toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
              }
            )}
          </p>
          <p className="mb-1">
            <strong>Age:</strong> {empDetails?.employee?.age}
          </p>

          <p className="mb-1">
            <strong>Phone Number:</strong> {empDetails?.employee?.mobileNumber}
          </p>
        </>
      ) : (
        <>
          <p className="mb-1">
            <strong>Username:</strong> {empDetails?.username}
          </p>
          <p className="mb-1">
            <strong>Email:</strong> {empDetails?.email}
          </p>
          <p className="border border-1 rounded-1 p-2">
            <b className="text-muted">Applicant</b>
          </p>
        </>
      )}

      {/* Buttons */}
      <div className="mt-3">
        <button
          className="btn text-white w-100"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickReset()}
        >
          Reset Password
        </button>
      </div>
      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn text-dark flex-grow-1 me-2"
          style={{ backgroundColor: "#e5e5e5" }}
          onClick={() => clickEdit()}
        >
          Edit
        </button>
        <button
          className="btn bg-danger text-white flex-grow-1"
          // style={{ backgroundColor: "#3f7cc0" }}
          onClick={() => clickDelete()}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default EmployeeDetails;
